import { SafeHtml } from '@app/components/core/safeHtml/SafeHtml'
import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { useTranslations } from '@i18n/useLanguage'

export const TopicCommunityPageContact = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => {
  const t = useTranslations().app.topicCommunityPage
  const contactHtml = topicCommunity?.contactInfo

  if (!contactHtml) {
    return <p style={{ color: 'var(--gray-300)' }}>{t.noContact}</p>
  }

  return <SafeHtml html={contactHtml} />
}
